import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const SESSION_KEY = "ripp_nft_session";
const TIER_RING = { GENESIS: "ring-[#F5C451] shadow-[0_0_18px_rgba(245,196,81,0.55)]", LEGENDARY: "ring-fuchsia-400 shadow-[0_0_16px_rgba(232,121,249,0.5)]", EPIC: "ring-violet-400", RARE: "ring-cyan-400", UNCOMMON: "ring-emerald-400", COMMON: "ring-zinc-500" };
const API = process.env.REACT_APP_BACKEND_URL;
const mediaUrl = (u) => (u && u.startsWith("/") ? `${API}${u}` : u);

export const HolderBadge = () => {
  const [sc, setSc] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem(SESSION_KEY);
    if (!token) return;
    let alive = true;
    fetch(`${API}/api/nft/holder-access`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive && d?.holder && d.showcase) setSc({ ...d.showcase, level: d.access_level }); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!sc) return null;
  const ring = TIER_RING[sc.tier] || TIER_RING.COMMON;
  return (
    <Link to="/ripp/holder" title={`${sc.name} · ${sc.character} · ${sc.tier} — ${sc.held} RIPP${sc.held === 1 ? "" : "s"} held · access ${sc.level}`} data-testid="holder-badge"
      className="flex items-center gap-2 pl-1 pr-2 py-0.5 rounded-full border border-zinc-800 bg-black/60 hover:border-zinc-600 transition-colors duration-150">
      <span className={`relative h-8 w-8 rounded-full overflow-hidden ring-2 ${ring} bg-black`}>
        {sc.animation ? <video src={mediaUrl(sc.animation)} className="h-full w-full object-cover scale-[1.35]" autoPlay loop muted playsInline data-testid="holder-badge-video" />
                      : <img src={mediaUrl(sc.image)} alt="" className="h-full w-full object-cover" data-testid="holder-badge-image" />}
      </span>
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] font-bold tracking-wider text-zinc-100" data-testid="holder-badge-name">{sc.name}</span>
        <span className="text-[9px] uppercase tracking-[0.18em] text-[#F5C451]" data-testid="holder-badge-tier">{sc.tier} · {sc.level}</span>
      </span>
    </Link>
  );
};
